<template>
    <div>



        <div v-if="postContent.text ">

            <TextPostType
                    :postContent="postContent"
                    >

            </TextPostType>
        </div>

    </div>
</template>


<script>
  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')
  import Likes from '@/components/Likes/Likes'

  import TextPostType from '@/components/Posts/Types/TextPostType'
  import MediaPostType from './Types/MediaPostType'

  export default {
    name:       'Post',
    components: {
      MediaPostType,
      Likes,
      TextPostType,
    },
    props:      [
      'postContent',
      'target'
    ],
    data ()
    {
      return {}
    },
    mounted ()
    {

    },
    filters:    {},
    computed:   {

      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

    },
    getters:    {},
    methods:    {},
    watch:      {
      threadId ()
      {

        var that = this

      }

    }
  }

</script>


<style>


</style>
